import React from "react";
import { Dropdown } from "semantic-ui-react";

function InputDropdown({ objData, objFieldName, options, onChange, ...props }) {
  return (
    <Dropdown
      onChange={(e, { sq, value }) =>
        onChange({ fieldName: objFieldName, value })
      }
      options={options}
      value={objData[objFieldName] || options[0].value}
      {...props}
    />
  );
}

export default InputDropdown;
